import { LoginHistoryConstants } from "../constants/loginhistory.constants";

const LoginHistoriesReducer = (state, action) => {
  switch (action.type) {
    case LoginHistoryConstants.FETCH_LOGINHISTORY_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case LoginHistoryConstants.FETCH_LOGINHISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loginHistories: action.payload.data,
        paging: action.payload.paging,
      };
    case LoginHistoryConstants.FETCH_LOGINHISTORY_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case LoginHistoryConstants.LOGINHISTORY_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case LoginHistoryConstants.LOGINHISTORY_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loginHistorySearchResults: action.payload,
      };
    case LoginHistoryConstants.LOGINHISTORY_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case LoginHistoryConstants.LOGINHISTORY_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case LoginHistoryConstants.LOGINHISTORY_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loginHistoryAutoSearchResults: action.payload,
      };
    case LoginHistoryConstants.LOGINHISTORY_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case LoginHistoryConstants.GET_LOGINHISTORY_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case LoginHistoryConstants.GET_LOGINHISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loginHistory: action.payload,
      };
    case LoginHistoryConstants.GET_LOGINHISTORY_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case LoginHistoryConstants.DOWNLOAD_LOGINHISTORY_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case LoginHistoryConstants.DOWNLOAD_LOGINHISTORY_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case LoginHistoryConstants.DOWNLOAD_LOGINHISTORY_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };

    default:
      return state;
  }
};

export default LoginHistoriesReducer;
